
import { ConfigCliente } from '../../configuracoes/app/cliente';
import { CustomerShareValueObject } from '../../pic/customer-share';
import { ClienteAnaliseMercadoSearchCliente } from './cliente-analise-mercado-search-cliente';
import { calcularQuantidadePretendidaPerc, calcularPesoPretendidoPerc, calcularValorPretendidoPerc } from '../calculo/pretendido';
import { calcularQuantidadeProjetadaPerc, calcularPesoProjetadoPerc, calcularValorProjetadoPerc } from '../calculo/projetado';
import { calcularQuantidadeRealizadaPerc, calcularPesoRealizadoPerc, calcularValorRealizadoPerc } from '../calculo/realizado';

export class ClienteAnaliseMercadoSearchClienteTotal {
    // Quantidade Potencial
    quantidadePotencial = 0;
    // Peso Potencial
    pesoPotencial = 0;
    // Valor Potencial
    valorPotencial = 0;

    // Quantidade Pretendida
    quantidadePretendida = 0;
    quantidadePretendidaPerc = 0;
    // Peso Pretendido
    pesoPretendido = 0;
    pesoPretendidoPerc = 0;
    // Valor Pretendido
    valorPretendido = 0;
    valorPretendidoPerc = 0;
    indicadorCustomerSharePretendido = 0;

    // Quantidade Projetada
    quantidadeProjetada = 0;
    quantidadeProjetadaPerc = 0;
    // Peso Projetado
    pesoProjetado = 0;
    pesoProjetadoPerc = 0;
    // Valor Projetado
    valorProjetado = 0;
    valorProjetadoPerc = 0;

    // Quantidade Realizada
    quantidadeRealizada = 0;
    quantidadeRealizadaPercPretendida = 0;
    quantidadeRealizadaPercProjetada = 0;
    // Peso Realizado
    pesoRealizado = 0;
    pesoRealizadoPercPretendido = 0;
    pesoRealizadoPercProjetado = 0;
    // Valor Realizado
    valorRealizado = 0;
    valorRealizadoPerc = 0;
    indicadorCustomerShareRealizado: number;
    valorRealizadoPercPretendido = 0;
    valorRealizadoPercProjetado = 0;

    /** Remove os valores da análise do cliente aos valores totais */
    removeCliente(cliente: ClienteAnaliseMercadoSearchCliente, configCliente: ConfigCliente) {
        if (!cliente) {
            return;
        }

        // Quantidade Potencial
        this.quantidadePotencial -= cliente.quantidadePotencial && !isNaN(cliente.quantidadePotencial) ? Number(cliente.quantidadePotencial) : 0;
        // Peso Potencial
        this.pesoPotencial -= cliente.pesoPotencial && !isNaN(cliente.pesoPotencial) ? Number(cliente.pesoPotencial) : 0;
        // Valor Potencial
        this.valorPotencial -= cliente.valorPotencial && !isNaN(cliente.valorPotencial) ? Number(cliente.valorPotencial) : 0;

        // Quantidade Pretendida
        this.quantidadePretendida -= cliente.quantidadePretendida && !isNaN(cliente.quantidadePretendida) ? Number(cliente.quantidadePretendida) : 0;
        // Peso Pretendido
        this.pesoPretendido -= cliente.pesoPretendido && !isNaN(cliente.pesoPretendido) ? Number(cliente.pesoPretendido) : 0;
        // Valor Pretendido
        this.valorPretendido -= cliente.valorPretendido && !isNaN(cliente.valorPretendido) ? Number(cliente.valorPretendido) : 0;

        // Quantidade Projetada
        this.quantidadeProjetada -= cliente.quantidadeProjetada && !isNaN(cliente.quantidadeProjetada) ? Number(cliente.quantidadeProjetada) : 0;
        // Peso Projetado
        this.pesoProjetado -= cliente.pesoProjetado && !isNaN(cliente.pesoProjetado) ? Number(cliente.pesoProjetado) : 0;
        // Valor Projetado
        this.valorProjetado -= cliente.valorProjetado && !isNaN(cliente.valorProjetado) ? Number(cliente.valorProjetado) : 0;

        // Quantidade Realizada
        this.quantidadeRealizada -= cliente.quantidadeRealizada && !isNaN(cliente.quantidadeRealizada) ? Number(cliente.quantidadeRealizada) : 0;
        // Peso Realizado
        this.pesoRealizado -= cliente.pesoRealizado && !isNaN(cliente.pesoRealizado) ? Number(cliente.pesoRealizado) : 0;
        // Valor Realizado
        this.valorRealizado -= cliente.valorRealizado && !isNaN(cliente.valorRealizado) ? Number(cliente.valorRealizado) : 0;

        // Calculando Customer Share Total
        this.calcularCustomerShare(configCliente);
    }

    /** Adiciona os valores da análise do cliente aos valores totais */
    addCliente(cliente: ClienteAnaliseMercadoSearchCliente, configCliente: ConfigCliente) {
        if (!cliente) {
            return;
        }

        // Quantidade Potencial
        this.quantidadePotencial += cliente.quantidadePotencial && !isNaN(cliente.quantidadePotencial) ? Number(cliente.quantidadePotencial) : 0;
        // Peso Potencial
        this.pesoPotencial += cliente.pesoPotencial && !isNaN(cliente.pesoPotencial) ? Number(cliente.pesoPotencial) : 0;
        // Valor Potencial
        this.valorPotencial += cliente.valorPotencial && !isNaN(cliente.valorPotencial) ? Number(cliente.valorPotencial) : 0;

        // Quantidade Pretendida
        this.quantidadePretendida += cliente.quantidadePretendida && !isNaN(cliente.quantidadePretendida) ? Number(cliente.quantidadePretendida) : 0;
        // Peso Pretendido
        this.pesoPretendido += cliente.pesoPretendido && !isNaN(cliente.pesoPretendido) ? Number(cliente.pesoPretendido) : 0;
        // Valor Pretendido
        this.valorPretendido += cliente.valorPretendido && !isNaN(cliente.valorPretendido) ? Number(cliente.valorPretendido) : 0;

        // Quantidade Projetada
        this.quantidadeProjetada += cliente.quantidadeProjetada && !isNaN(cliente.quantidadeProjetada) ? Number(cliente.quantidadeProjetada) : 0;
        // Peso Projetado
        this.pesoProjetado += cliente.pesoProjetado && !isNaN(cliente.pesoProjetado) ? Number(cliente.pesoProjetado) : 0;
        // Valor Projetado
        this.valorProjetado += cliente.valorProjetado && !isNaN(cliente.valorProjetado) ? Number(cliente.valorProjetado) : 0;

        // Quantidade Realizada
        this.quantidadeRealizada += cliente.quantidadeRealizada && !isNaN(cliente.quantidadeRealizada) ? Number(cliente.quantidadeRealizada) : 0;
        // Peso Realizado
        this.pesoRealizado += cliente.pesoRealizado && !isNaN(cliente.pesoRealizado) ? Number(cliente.pesoRealizado) : 0;
        // Valor Realizado
        this.valorRealizado += cliente.valorRealizado && !isNaN(cliente.valorRealizado) ? Number(cliente.valorRealizado) : 0;

        // Calculando Customer Share Total
        this.calcularCustomerShare(configCliente);
    }

    /** Calcula o Customer Share Total */
    private calcularCustomerShare(configCliente: ConfigCliente) {
        const customerShare = new CustomerShareValueObject(configCliente.customerShareOtimo, configCliente.customerShareBom, configCliente.customerShareRazoavel, this.valorPotencial, this.valorPretendido, this.valorRealizado);

        // Quantidade Pretendida
        this.quantidadePretendidaPerc = calcularQuantidadePretendidaPerc(this.quantidadePretendida, this.quantidadePotencial);
        // Peso Pretendido
        this.pesoPretendidoPerc = calcularPesoPretendidoPerc(this.pesoPretendido, this.pesoPotencial);
        // Valor Pretendido
        this.valorPretendidoPerc = customerShare.valorPretendidoPerc;
        this.indicadorCustomerSharePretendido = customerShare.indicadorPretendido.id;

        // Quantidade Projetada
        this.quantidadeProjetadaPerc = calcularQuantidadeProjetadaPerc(this.quantidadeProjetada, this.quantidadePotencial);
        // Peso Projetado
        this.pesoProjetadoPerc = calcularPesoProjetadoPerc(this.pesoProjetado, this.pesoPotencial);
        // Valor Projetado
        this.valorProjetadoPerc = calcularValorProjetadoPerc(this.valorProjetado, this.valorPotencial);

        // Quantidade Realizada
        this.quantidadeRealizadaPercPretendida = calcularQuantidadeRealizadaPerc(this.quantidadeRealizada, this.quantidadePretendida);
        this.quantidadeRealizadaPercProjetada = calcularQuantidadeRealizadaPerc(this.quantidadeRealizada, this.quantidadeProjetada);
        // Peso Realizado
        this.pesoRealizadoPercPretendido = calcularPesoRealizadoPerc(this.pesoRealizado, this.pesoPretendido);
        this.pesoRealizadoPercProjetado = calcularPesoRealizadoPerc(this.pesoRealizado, this.pesoProjetado);
        // Valor Realizado
        this.valorRealizadoPerc = customerShare.valorRealizadoPerc;
        this.indicadorCustomerShareRealizado = customerShare.indicadorRealizado.id;
        this.valorRealizadoPercPretendido = calcularValorRealizadoPerc(this.valorRealizado, this.valorPretendido);
        this.valorRealizadoPercProjetado = calcularValorRealizadoPerc(this.valorRealizado, this.valorProjetado);
    }
}
